export const searchAnnexuresDataURL = (page) => {
  return `/finance/annexure/search/?page=${page}`;
};

export const searchFalconAnnexuresDataURL = (page) => {
  return `/finance/falcon-annexure/search/?page=${page}`;
};

export const createFalconAnnexureURL = () => {
  return `/finance/falcon-annexure/`;
};

export const viewFalconAnnexureURL = (annexureId) => {
  return `/finance/falcon-annexure/${annexureId}/`;
};

export const approveAnnexureURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/approve/`;
};

export const rejectAnnexureURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/reject/`;
};

export const commentAnnexureURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/comment/`;
};

export const falconCommentAnnexureURL = (annexureId) => {
  return `/finance/falcon-annexure/${annexureId}/comment/`;
};

export const othersHeaderEditURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/edit_others_name/`;
};

export const deleteAnnexuresURL = () => {
  return `/finance/annexure/delete/`;
};

export const deleteFalconAnnexureURL = (annexureId) => {
  return `/finance/falcon-annexure/${annexureId}/delete/`;
};

export const createFalconAdhocCNURL = (annexureId) => {
  return `/finance/falcon-annexure/${annexureId}/create_adhoc_cn/`;
};

export const sendForApprovalURL = () => {
  return `/finance/annexure/send_for_approval/`;
};

export const saveBillDetailsURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/save_bill_details/`;
};

export const falconSaveBillDetailsURL = (annexureId) => {
  return `/finance/falcon-annexure/${annexureId}/save_bill_details/`;
};

export const annexureUploadBillURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/upload_bill/`;
};

export const createNextAnnexureURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/create_next_annexure/`;
};

export const getAnnexuresDataURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/`;
};

export const editAnnexureTripRevenueURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/`;
};

export const getSearchAnnexuresDataURL = () => {
  return `/finance/annexure/initial/`;
};

export const editAnnexureDieselDateURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/edit_diesel_date/`;
};

export const deleteTripsAnnexureURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/annexure_delete_trips/`;
};

export const printAnnexureURL = (annexureId) => {
  return `/finance/annexure/${annexureId}/?print=true`;
};

//SEND TO TALLY

export const searchApprovedAnnexuresDataURL = (page) => {
  return `/tally/tallyannexure/search/?page=${page}`;
};

export const generateBillOnTallyURL = () => {
  return `/tally/tallyannexure/annexures_tally_send/`;
};

export const resendToTallyURL = () => {
  return `/tally/resend-annexure`;
};

export const fetchRentalAnnexuresInitialDataURL = () => {
  return `/finance/rental-annexure/initial_data/`;
};

export const searchRentalAnnexuresDataURL = (params = {}) => {
  const query = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return `/finance/rental-annexure/${query ? `?${query}` : ''}`;
};

export const fetchRentalAnnexureTrackURL = (page) => {
  return `/finance/rental-annexure/track/?page=${page}`;
};

export const saveRentalAnnexuresUploadDataURL = () => {
  return `/finance/rental-annexure/`;
};

export const saveBillDetailsRentalAnnexuresURL = (annexureId) => {
  return `/finance/rental-annexure/${annexureId}/save_bill_details/`;
};

export const createAdHocAnnexureURL = (annexId) => {
  return `/finance/annexure/${annexId}/create_adhoc_annexure/`;
};
